
const quickDateConvert = (date) =>
    {
        const temp = date ? date.substring(0,10) : ""
        return temp == '1870-07-29' ? "" : temp
    }

const MocHelper = {
    quickDateConvert
}

export default MocHelper;